module.exports = __webpack_public_path__ + "img/17_39.48d407ec.png";